import { AUTHORIZATIONS_ROUTES } from './constants';
import AuthorizationFormLayout from './components/AuthorizationFormLayout';

export default [
    {
        path: AUTHORIZATIONS_ROUTES.NEW,
        component: AuthorizationFormLayout
    }
];
